import { render } from "./AlgoliaResultCard.vue?vue&type=template&id=8fb9dc58&scoped=true"
import script from "./AlgoliaResultCard.vue?vue&type=script&lang=js"
export * from "./AlgoliaResultCard.vue?vue&type=script&lang=js"

import "./AlgoliaResultCard.vue?vue&type=style&index=0&id=8fb9dc58&scoped=true&lang=css"

import exportComponent from "/home/forge/princes-trust.ac.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fb9dc58"]])

export default __exports__